export class Exposure {
    exposureId: number;
    name: string;
    exposureCategoryId1?: number;
    exposureCategoryId2?: number;
    exposureCategoryId3?: number;
    possInsVal?: number;
    approxInsVal?: number;
    ratingAreaID?: number;
    lossDetails: string;
    onShoreOffShoreId: number;
    onShoreInd?: number;
    productInformation: string;
    projectedTotalDepth: string;
    plantCapacity: string;
    waterDepth?: string;
    waterDepthCategoryId?: string;
    rigDescription: number;
    dynamicallyPositioned?: number;
    // dp?:number;
    towId?: number;
    relatedWaterDepth?: number;
    generation?: number;
    buildDate?: string;
    installationDate?: string;
    inspectionDate?: DateTimeFormat;
    lastUpgradeDate?: DateTimeFormat;
    purchaseDate?: DateTimeFormat;
    usedAtPurchase?: string;
    assetCategoryId?: number;
    assetDescriptionId?: number;
    rebuiltYear?: string;
    shale?: boolean;
    shaleFormation: number;
    devlExpl?: number;
    wellTypeId?: number;
    drillingStatusId?: number;
    equipmentTypeId?: number;
    model?: number;
    modelBuildYear?: number;
    modelOEM?: number;
    countryManufactured?: number;
    transit?: boolean;
    fieldUnit?: string;
    oilMulti: boolean;
    operationalStatusId?: number;
    rigDetailsChk: boolean;
}


// WEBPACK FOOTER //
// ./src/app/modules/validate-loss-data-submission/shared/entities/exposure.ts